module.exports = __webpack_public_path__ + "static/media/no-text-branco.eb71cc14.svg";